import { render, staticRenderFns } from "./ManageSuppliers.vue?vue&type=template&id=acc2bed8"
import script from "./ManageSuppliers.vue?vue&type=script&lang=ts"
export * from "./ManageSuppliers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports